import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import L from 'leaflet';

import {MapSetup, FunctionsReactStateSetup, map, ResetMapState } from './content/js/Main.js';

import { useAuth } from './content/react-components/AuthContext';

import 'leaflet/dist/leaflet.css';

const Map = ({ onMarkerClick, onBottomMarkerClick, onSideBar }) => {

  const navigate = useNavigate();

  const handleMarkerClick = (typecode, id, name, setOpen, setEdit) => {
    // Вызываем переданный обратный вызов при клике на маркер
    onMarkerClick(typecode, id, name, setOpen, setEdit);
    // Тут можно также выполнить дополнительные действия, связанные с картой
  };

  const handleBottomMarkerClick = (linkedtp) => {
    // Вызываем переданный обратный вызов при клике на маркер
    onBottomMarkerClick(linkedtp);
    // Тут можно также выполнить дополнительные действия, связанные с картой
  };

  const handleSideBar = (isSidebar) => {
    onSideBar(isSidebar);
  }

  const { user, userId, depname, permissions, logout } = useAuth();

  const handleLogOut = () => {
    logout();
    localStorage.removeItem('user');
    navigate("/login");
  }

    useEffect(() => {
        MapSetup(depname, user, userId, permissions);
        return () => {
          if (map) map.remove();
          ResetMapState();
        };
      }, []);
      
  FunctionsReactStateSetup(handleMarkerClick, handleBottomMarkerClick, handleLogOut, handleSideBar);

  return <div id="map" style={{ height: '100vh' }}></div>;
};


export default Map;